module.exports = __webpack_public_path__ + "img/Guinea.22405189.png";